<template>
  <!-- 平台方 -->
  <div class="page">
    <!-- 搜索区域 -->
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="auto" class="from">
        <el-form-item :label="$t('pages.operate.text1')">
          <el-input
            v-model="searchParams.platformAllName"
            :placeholder="$t('public.text1')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.operate.text2')">
          <el-select
            v-model="searchParams.status"
            :placeholder="$t('public.text5')"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('pages.operate.text3')">
          <el-date-picker
            v-model="searchParams.serveStartTime"
            type="datetime"
            :placeholder="$t('public.text2')"
            :picker-options="pickerOptions0"
            @change="startChange"
          >
          </el-date-picker>
          <span style="margin: 0 8px">-</span>
          <el-date-picker
            v-model="searchParams.serveStopTime"
            type="datetime"
            :placeholder="$t('public.text3')"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="searchSubmit">
        <DiluButton
          type="search"
          @click="search"
          v-permission="['platform:query']"
        ></DiluButton>
        <DiluButton
          type="reset"
          @click="reset"
          v-permission="['platform:reset']"
        ></DiluButton>
      </div>
    </div>

    <!-- 表格 -->
    <div class="platfro-ul">
      <el-card
        class="add-platfor"
        @click.native="add"
        shadow="never"
        v-permission="['platform:add']"
        ><i class="el-icon-plus add"></i
      ></el-card>
      <el-card
        class="platfor-li"
        v-for="(item, index) in tableData"
        :key="index"
        shadow="never"
      >
        <div :class="[item.status == 0 ? 'status' : 'status-false']">
          <div class="text">
            {{
              item.status == 0
                ? $t("pages.operate.text4")
                : $t("pages.operate.text5")
            }}
          </div>
        </div>

        <div class="operation">
          <el-dropdown @command="handleCommand">
            <div class="el-dropdown-link">
              <span></span><span></span><span></span>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="{ type: 'edit', item }"
                v-permission="['platform:edit']"
                >{{ $t("button.edit") }}</el-dropdown-item
              >
              <el-dropdown-item
                :command="{ type: 'reset', item }"
                v-permission="['platform:resetPwd']"
                >{{ $t("button.resetPassword") }}</el-dropdown-item
              >
              <el-dropdown-item
                :command="{ type: 'share', item }"
                v-permission="['platform:share']"
                >{{ $t("button.sharing") }}</el-dropdown-item
              >
              <!-- <el-dropdown-item
                :command="{ type: 'remove', item }"
                v-permission="['platform:remove']"
                >删除</el-dropdown-item
              > -->
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <div class="platfor-li-content">
          <div class="platfor-li-content-title">
            {{ item.platformShortName }}
          </div>
          <span
            :class="[
              item.platformProperty == 0
                ? 'platfor-li-content-label'
                : 'platfor-li-content-label-false',
            ]"
            >{{
              item.platformProperty == 0
                ? $t("pages.operate.text51")
                : $t("pages.operate.text50")
            }}
            {{ item.appCode }}</span
          >
          <div class="platfor-li-content-text">
            {{ $t("pages.operate.text6") }}:{{ item.username }}
          </div>
          <div class="platfor-li-content-text">
            {{ $t("pages.operate.text7") }}:{{ item.bikeNum }}
          </div>
          <div class="platfor-li-content-text">
            {{ $t("pages.operate.text8") }}:{{ item.serveStartTime }}
          </div>
          <div class="platfor-li-content-text">
            {{ $t("pages.operate.text9") }}:{{ item.serveStopTime }}
          </div>
        </div>
      </el-card>
    </div>
    <div class="dilu-pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="searchParams.pageSize"
        @current-change="currentChange"
      >
      </el-pagination>
    </div>
    <!-- 分享弹窗 -->
    <AccountShareModule
      @shareClose="shareClose"
      :shareVisible="shareVisible"
      :shareInfo="shareInfo"
    />
  </div>
</template>


<script>
import AccountShareModule from "../../system/platformPermissions/module/accountShareModule.vue";
import DiluButton from "../../../components/pubilc/dilu-button.vue";
import { mapState } from "vuex";
import { resetDate } from "../../../utils/util/validate";
import { randomString } from "../../../utils/util/validate";
export default {
  data() {
    return {
      pickerOptions0: {
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));

              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < this.searchParams.serveStartTime;
        },
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));

              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      searchTime: "", //搜索时间
      searchParams: {
        belongCustomerId: "", // 平台方id
        pageNum: 1, // 页码
        pageSize: 14, // 每页条数
        platformAllName: "", //平台方全称/简称
        serveStartTime: "", // 服务开始时间
        serveStopTime: "", // 服务结束时间
        status: null, // 状态
      },
      shareInfo: {}, //分享数据
      shareVisible: false, //分享弹窗
      total: 0,
      tableData: [],
      options: [
        {
          label: this.$t("pages.operate.text10"),
          value: null,
        },
        {
          label: this.$t("pages.operate.text4"),
          value: "0",
        },
        {
          label: this.$t("pages.operate.text5"),
          value: "1",
        },
      ],
    };
  },
  components: {
    DiluButton,
    AccountShareModule,
  },
  computed: {
    ...mapState(["platformData"]),
  },
  mounted() {
    this.platformList();
  },
  methods: {
    //搜索
    search() {
      this.searchParams.pageNum = 1;
      this.total = 0;
      this.platformList();
    },
    startChange() {
      this.searchParams.serveStopTime = null;
    },
    //关闭分享弹窗
    shareClose() {
      this.shareVisible = false;
    },

    //新增
    add() {
      this.$router.push({
        path: "/operate/platformManagement/addPlatform",
        query: {
          pageState: "ADD",
        },
      });
    },
    //操作按钮
    handleCommand(e) {
      //修改
      if (e.type == "edit") {
        this.$router.push({
          path: "/operate/platformManagement/addPlatform",
          query: {
            pageState: "EDIT",
            id: e.item.id,
          },
        });
      }
      //删除
      if (e.type == "remove") {
        this.$confirm(
          this.$t("pages.operate.text11"),
          this.$t("public.text6"),
          {
            confirmButtonText: this.$t("button.determine"),
            cancelButtonText: this.$t("button.cancel"),
            type: "warning",
          }
        )
          .then(() => {
            this.request.platformDelete(e.item.id).then(() => {
              this.platformList();
              this.$message({
                type: "success",
                message: this.$t("public.text7"),
              });
            });
          })
          .catch(() => {});
      }
      //重置密码
      if (e.type == "reset") {
        this.$confirm(
          this.$t("pages.operate.text12"),
          this.$t("public.text6"),
          {
            confirmButtonText: this.$t("button.determine"),
            cancelButtonText: this.$t("button.cancel"),
            type: "warning",
          }
        )
          .then(() => {
            let psw =
              "belongCustomerId=" + e.item.id + "&password=" + randomString(6);
            this.request.platformResetPlatformAdminPassword(psw).then(() => {
              this.$message({
                type: "success",
                message: this.$t("pages.operate.text13"),
              });
            });
          })
          .catch(() => {});
      }
      //一键分享
      if (e.type == "share") {
        this.request.platformSharePlatformInfo(e.item.id).then((res) => {
          this.shareInfo = {
            password: res.data.adminPassword,
            username: res.data.adminUsername,
            domain: res.data.platformDomain,
          };
          this.shareVisible = true;
        });
      }
    },
    //平台方管理-列表（分页）
    platformList() {
      this.searchParams.belongCustomerId = this.platformData.id;
      if (this.searchParams.serveStartTime && this.searchParams.serveStopTime) {
        this.searchParams.serveStartTime = resetDate(
          this.searchParams.serveStartTime
        ); // 服务开始时间
        this.searchParams.serveStopTime = resetDate(
          this.searchParams.serveStopTime
        ); // 服务结束时间
      }
      if (this.searchParams.serveStartTime) {
        if (!this.searchParams.serveStopTime) {
          return this.$message.error(this.$t("public.text3"));
        }
      }
      if (this.searchParams.serveStopTime) {
        if (!this.searchParams.serveStartTime) {
          return this.$message.error(this.$t("public.text2"));
        }
      }
      this.request.platformList(this.searchParams).then((res) => {
        this.tableData = res.data;
        this.total = res.dataMaxCount;
      });
    },
    //翻页
    currentChange(e) {
      this.searchParams.pageNum = e;
      this.platformList();
    },
    //重置
    reset() {
      this.searchParams = {
        belongCustomerId: "", // 平台方id
        pageNum: 1, // 页码
        pageSize: 10, // 每页条数
        platformAllName: "", //平台方全称/简称
        serveStartTime: "", // 服务开始时间
        serveStopTime: "", // 服务结束时间
        status: null, // 状态
      };
      this.total = 0;
      this.platformList();
    },
  },
};
</script>

<style scoped>
.page {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.from {
  float: left;
  display: flex;
}
.searchSubmit {
  float: right;
  display: flex;
}
.operation {
  margin-bottom: 16px;
  display: flex;
  position: absolute;
  right: 20px;
  top: 15px;
  width: 20px;
  justify-content: space-between;
  display: flex;
}

.platfro-ul {
  display: flex;
  flex-wrap: wrap;
  flex: 1;
}
.add-platfor {
  width: 280px;
  height: 215px;
  background: #ffffff;
  opacity: 1;
  border-radius: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-right: 15px;
  margin-bottom: 15px;
  border-radius: 8px;
}
.add {
  font-size: 72px;
  color: #f0f3fa;
}
.platfor-li {
  width: 280px;
  height: 215px;
  background: #ffffff;
  opacity: 1;
  border-radius: 0px;
  cursor: pointer;
  margin-right: 15px;
  margin-bottom: 15px;
  overflow: initial;
  position: relative;
  padding: 20px 0;
  box-sizing: border-box;
  border-radius: 8px;
}

.platfor-li:hover {
  border: 1px solid #1f5bcc;
  box-shadow: 0 0 20px #c8d0e7;
}
.status {
  position: absolute;
  width: 50px;
  height: 0px;
  border-left: 24px solid transparent;
  border-top: 24px solid #1f5bcc;
  border-right: 24px solid transparent;
  top: 0;
  left: 30px;
  border-radius: 2px;
}
.status-false {
  position: absolute;
  width: 72px;
  height: 0px;
  border-left: 24px solid transparent;
  border-top: 24px solid#D7DDEB;
  border-right: 24px solid transparent;
  top: 0;
  left: 30px;
  border-radius: 2px;
}
.status-false .text {
  color: #fff;
  font-size: 12px;
  position: absolute;
  left: 0;
  right: 0;
  top: -21px;
  margin: auto;
  text-align: center;
}
.status .text {
  color: #fff;
  font-size: 12px;
  position: absolute;
  left: 0;
  right: 0;
  top: -21px;
  margin: auto;
  text-align: center;
}
.dilu-pagination {
  margin: 20px 0;
  display: flex;
  justify-content: flex-end;
}
.platfor-li-content {
  width: 100%;
  height: 100%;
}
.platfor-li-content-title {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #000000;
  margin-bottom: 10px;
}
.platfor-li-content-label {
  background: #ffffff;
  border: 1px solid #1f5bcc;
  opacity: 1;
  border-radius: 11px;
  text-align: center;
  padding: 1px 6px;
  font-size: 12px;
  color: #1f5bcc;
  margin-bottom: 18px;
  display: inline-block;
}
.platfor-li-content-label-false {
  color: #efa22b;
  border: 1px solid #efa22b;
  background: #ffffff;
  opacity: 1;
  border-radius: 11px;
  text-align: center;
  padding: 1px 6px;
  font-size: 12px;
  margin-bottom: 18px;
  display: inline-block;
}
.platfor-li-content-text {
  font-size: 12px;
  color: #000000;
}
.el-dropdown-link {
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: space-between;
}
.el-dropdown-link span {
  width: 4px;
  height: 4px;
  background: #d7ddeb;
  border-radius: 50%;
}
</style>